import {
    NotEnoughFreeCollateralError,
    SDKError,
    UnableToQuoteError,
    UniswapBrokerInsufficientLiquidityError,
} from "@perp/sdk-curie"
import { PRICE_IMPACT_PERCENTAGE_PRECISION } from "constant/number"
import { usePositionDraftDetail } from "sdk-react/clearingHouse/usePositionDraftDetail"
import { formatNumberUSD, formatPercentage } from "util/format"

const PLACEHOLDER = "-"

function shouldShowPlaceHolder(targetError: SDKError) {
    const errs = [UnableToQuoteError, UniswapBrokerInsufficientLiquidityError, NotEnoughFreeCollateralError]

    return errs.some(err => targetError instanceof err)
}

export function usePositionDraftDetailStrings() {
    const { buyingPower, mmRatio, entryPrice, priceImpact, transactionFee, error } = usePositionDraftDetail()

    const buyingPowerStr = buyingPower ? `${formatNumberUSD({ num: buyingPower })}` : PLACEHOLDER

    if (error && shouldShowPlaceHolder(error)) {
        return {
            buyingPowerStr,
            maintenanceMarginRatioStr: PLACEHOLDER,
            entryPriceStr: PLACEHOLDER,
            priceImpactStr: PLACEHOLDER,
            transactionFeeStr: PLACEHOLDER,
            nextLeverageStr: PLACEHOLDER,
            nextMarginRatioStr: PLACEHOLDER,
            nextLiquidationPriceStr: PLACEHOLDER,
            nextFreeCollateralStr: PLACEHOLDER,
        }
    }
    const maintenanceMarginRatioStr = mmRatio ? `${formatPercentage(mmRatio)}%` : PLACEHOLDER
    const entryPriceStr = entryPrice ? formatNumberUSD({ num: entryPrice }) : PLACEHOLDER
    const priceImpactStr = priceImpact
        ? `${formatPercentage(priceImpact, true, false, PRICE_IMPACT_PERCENTAGE_PRECISION)}%`
        : PLACEHOLDER
    const transactionFeeStr = transactionFee ? `${formatNumberUSD({ num: transactionFee })}` : PLACEHOLDER

    return {
        buyingPowerStr,
        maintenanceMarginRatioStr,
        entryPriceStr,
        priceImpactStr,
        transactionFeeStr,
    }
}
